import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/globals.scss";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/reset.css";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import { theme } from "./styles/theme";
import { MessageProvider } from "./store/MessageContext";
import { AuthProvider } from "./store/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ConfigProvider theme={theme}>
      <MessageProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MessageProvider>
    </ConfigProvider>
  </BrowserRouter>,
  // </React.StrictMode>
);
